export default __webpack_public_path__ + "static/media/chainid-tag.dc944b68.svg";